export enum ManageMyBookingFlowEnum {
    None,
    Regular,
    ChangeFlights,
    Refund
}